import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LockNameComponent } from './lock-name.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [LockNameComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    MatButtonModule,
    TranslateModule
  ],
  exports: [LockNameComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class LockNameModule {}
